import PropTypes, {InferProps} from "prop-types";
import {ProfileCompletionView} from "./profile-completion.view";
import {usePersonView} from "@betrue/front/services";


export const ProfileCompletionPropsTypes = {
  descriptionLabel: PropTypes.string,
  chatLabel: PropTypes.string,
  skillsLabel: PropTypes.string,
  jobLabel: PropTypes.string,
  firstnameLabel: PropTypes.string,
  priceLabel: PropTypes.string,
  availableLabel: PropTypes.string,
  title: PropTypes.string,
  avatarLabel: PropTypes.string,
}
export type ProfileCompletionProps = InferProps<typeof ProfileCompletionPropsTypes>

export const ProfileCompletion = (props: ProfileCompletionProps) => {
  const [viewPerson, viewProfile] = usePersonView()
  if (!viewProfile || !viewPerson) return (<></>)

  return (
    <ProfileCompletionView {...props} person={viewPerson} profile={viewProfile}/>
  );
}

ProfileCompletion.propTypes = ProfileCompletionPropsTypes
